import { Fragment, useRef, useState, useEffect } from "react"
import useApi from "../hooks/useApi"
import useDialog from "../hooks/useDialog"
import HomeBar from "../components/HomeBar"
import HomeFooter from "../components/HomeFooter"
import Dialog from "../components/Dialog"
import ButtonPrimary from "../commons/ButtonPrimary"
import Textbox from "../commons/Textbox"
import Textarea from "../commons/Textarea"

export default function ContactPage(){

    const requestApi=useApi()
    const {changeDialog}=useDialog()

    const nameInput=useRef()
    const companyInput=useRef()
    const categoryInput=useRef()
    const phoneInput=useRef()
    const emailInput=useRef()
    const messageInput=useRef()

    const [formData,setFormData]=useState({
        name:"",
        company:"",
        category:"",
        phone:"",
        email:"",
        message:""
    })

    const submit=()=>{
        if(formData.name === ""){
            nameInput.current.focus()
        }else{
            if(formData.company === ""){
                companyInput.current.focus()
            }else{
                if(formData.phone === ""){
                    phoneInput.current.focus()
                }else{
                    if(formData.email === ""){
                        emailInput.current.focus()
                    }else{
                        if(formData.message === ""){
                            messageInput.current.focus()
                        }else{
                            requestApi("messages/create",{
                                    name:formData.name,
                                    company:formData.company,
                                    category:formData.category,
                                    phone:formData.phone,
                                    email:formData.email,
                                    message:formData.message
                                })
                                .then(data=>{
                                    if(data.status === "success"){
                                        changeDialog("contact_sent","","")
                                        setFormData(prev=>({
                                            ...prev,
                                            name:"",
                                            company:"",
                                            category:"",
                                            phone:"",
                                            email:"",
                                            message:""
                                        }))
                                    }else{
                                        changeDialog("generic_error","","")
                                    }
                                })
                        }
                    }
                }
            }
        }
    }

    useEffect(()=>{
        window.scrollTo({top:0,behavior:"smooth"})
        document.title="Cajero24 – Formulario de Contacto"
        const desc=document.querySelector('meta[name="description"]')
        if(desc){desc.setAttribute("content","Contactate con Cajero24 para soluciones de cobro: débito, crédito, QR y Debin.")}
        const ogTitle=document.querySelector('meta[property="og:title"]')
        if(ogTitle){ogTitle.setAttribute("content","Cajero24 – Formulario de Contacto")}
        const ogDesc=document.querySelector('meta[property="og:description"]')
        if(ogDesc){ogDesc.setAttribute("content","Envíanos tu consulta y te contactamos para integrar pagos digitales.")}
    },[])

    const noop=(e)=>{e&&e.preventDefault&&e.preventDefault()}

    return(
        <Fragment>
            <HomeBar context="contact" contactOpen={noop} aboutOpen={noop} faqsOpen={noop} alwaysOn={true} />
            <div className="contact-page">
                <div className="contact-page-frame">
                    <div className="contact-page-title">Contactanos</div>
                    <div className="contact-page-subtitle">Completa el formulario y nuestro equipo te contactará para ofrecerte una solución de pagos adaptada.</div>
                    <div className="modal-form noselect">
                        <Textbox ref={nameInput} label="Nombre completo" type="text" val={formData.name} setVal={(v)=>setFormData(prev=>({...prev,name:v}))} disabled={false} />
                        <Textbox ref={companyInput} label="Empresa, comercio o institución" type="text" val={formData.company} setVal={(v)=>setFormData(prev=>({...prev,company:v}))} disabled={false} />
                        <Textbox ref={categoryInput} label="Categoría o rubro" type="text" val={formData.category} setVal={(v)=>setFormData(prev=>({...prev,category:v}))} disabled={false} />
                        <Textbox ref={phoneInput} label="Teléfono/WhatsApp" type="text" val={formData.phone} setVal={(v)=>setFormData(prev=>({...prev,phone:v}))} disabled={false} />
                        <Textbox ref={emailInput} label="Email" type="text" val={formData.email} setVal={(v)=>setFormData(prev=>({...prev,email:v}))} disabled={false} />
                        <Textarea ref={messageInput} label="Mensaje" val={formData.message} setVal={(v)=>setFormData(prev=>({...prev,message:v}))} disabled={false} />
                        <div className="contact-page-action"><ButtonPrimary label="Enviar solicitud" clickEvent={submit} /></div>
                    </div>
                </div>
            </div>
            <HomeFooter context="home" contactOpen={noop} aboutOpen={noop} faqsOpen={noop} />
            <Dialog />
        </Fragment>
    )
}
